<div class="loader-container">
    <div class="spinner-container">
        <div class="spinner-border custom-loader" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
</div>


